import { render } from "./QuestionChoicesItem.vue?vue&type=template&id=ecc87ca8"
import script from "./QuestionChoicesItem.vue?vue&type=script&lang=js"
export * from "./QuestionChoicesItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__